import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {

    FormArray, FormBuilder, FormGroup
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { EmpInfo } from '../model/emp.model';
import { ModulePortalMappingEmpRoleInfo } from '../model/ModulePortalMappingEmpRole';
import { ModulePortalMappingMenuInfo } from '../model/ModulePortalMappingMenu';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { GlobalService } from '../service/global.service';

import {
    HttpClient,
    HttpHeaders
} from "@angular/common/http";
import {
    environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { ModulePortalInfo } from '../model/moduleportal';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-information-role',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './information-role.component.html',
  styleUrls: ['./information-role.component.css']
})
export class InformationRoleComponent implements OnInit {

  // Form Group Master
  InformationForm: FormGroup;
  form: FormGroup;
  public body: string;
  ProjectSaleListPromise: Promise<ModulePortalMappingEmpRoleInfo[]>
  ProjectSaleList: ModulePortalMappingEmpRoleInfo[]
  ProjectSaleListPromisereturn: Promise<ModulePortalMappingEmpRoleInfo[]>[]

  ProjectSaleLeadListPromise: Promise<ModulePortalMappingMenuInfo[]>
  ProjectSaleLeadList: ModulePortalMappingMenuInfo[]
  ProjectSaleLeadLsitPromisereturn: Promise<ModulePortalMappingMenuInfo[]>[]
  ModuleList: ModulePortalInfo[]
  CategoryList: LookupInfo[]
  StatusList: LookupInfo[]
  ProjectSaleTypeList: LookupInfo[]
  ProjectSalePhaseList: LookupInfo[]
  ProjectSaleCustomerTypeList: LookupInfo[]
  empList: EmpInfo[]
  empListLoad: EmpInfo[]
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  saleOrganizationList: SaleOrganizationInfo[]
  saleOrganizationPromise: Promise<SaleOrganizationInfo[]>
  saleOrganizationMaxList: SaleOrganizationInfo[]

  // array control
  itemsSupport: FormArray;

  flagduplicate: boolean;
  hidProjectSaleId: number

  // variable for loading
  //displayloading: boolean = false;
  //Msgloadding: string = '';

  // project sale id from parameter
  _ParamProjectGroup: string
  _ParamProjectGroupName: string
  _ParamRoleName: string

  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number
  public empcodeinit: string
  _EmpCode: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;
  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;
  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number
  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;
  baseurl: string;
  currentModuleID: number
  currentMenuSeq: number
  currentMenuID: number
  currentModuleDescription: string
  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private router: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    //GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSizeSmall;
    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    this.currentPageNumberEmp = 1;
    this.monthNameslist = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    this.yearlist = this.generateArrayOfYears();
    this.form = this.formBuilder.group({
      ProjectSaleCodeSearch: [null],
      ProjectSaleNameSearch: [null],
      ProjectSaleCompanyIdSearch: [null],
      ProjectSaleStatusSearch: [null],
      ProjectGroupMapping: [null],
      ProjectSaleCode: [null],
      RoleCode: [null],
      ModuleId: [null],
      FlagActive: [null],
      CreateBy: localStorage.getItem("EmpName_TH"),
      ProjectSaleType: [null],
      ProjectSaleCategory: [null],
      ProjectSaleTool: [null],
      ProjectSalePhase: [null],
      ProjectSaleBudget: [null],
      ProjectSaleExpectedClosePeriodMonth: [null],
      ProjectSaleExpectedClosePerioddYear: [null],
      ProjectSaleContactDate: [null],
      ProjectSaleContactPerson: [null],
      ProjectSaleContactEmail: [null],
      ProjectSaleContactTel: [null],
      ProjectSaleCustomerType: [null],
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      ProjectSaleRemark: [null],
      EmpCodeSearch: [null],
      EmpNameSearch: [null]
    });

    this.Clearinput();



    this.loadLookup('MENUMAPPINGSTATUS').then((data) => {
      this.StatusList = data;
    });

    this.loadModulePortal().then((data) => {
      this.ModuleList = data;
    });

    this.router.params.subscribe(params => {
      this._ParamProjectGroup = params['RoleCode'];
    });

    this.router.params.subscribe(params => {
      this._ParamRoleName = params['RoleName'];
    });

    this.router.params.subscribe(params => {
      this._ParamProjectGroupName = params['RoleStatusName'];
    });

    this.LoadSaleOrganizationLevel();
    this.LoadProjectSaleLead();

  }

  btnClick_SearchProjectSaleList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;
    this.LoadProjectSaleLead()
  }

  btnClick_SearchProjectSaleLeadList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;
    this.LoadProjectSaleLead()
  }
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();

    this.form.patchValue({
      ProjectGroupMapping: null,
      ProjectSaleCode: null,
      RoleCode: null,
      ModuleId: null,
      FlagActive: null,
      CreateBy: localStorage.getItem("EmpName_TH"),
      ProjectSaleType: null,
      ProjectSaleCategory: null,
      ProjectSaleTool: null,
      ProjectSalePhase: null,
      ProjectSaleBudget: null,
      ProjectSaleExpectedClosePeriodMonth: null,
      ProjectSaleExpectedClosePerioddYear: null,
      ProjectSaleContactDate: null,
      ProjectSaleContactPerson: null,
      ProjectSaleContactEmail: null,
      ProjectSaleContactTel: null,
      ProjectSaleCustomerType: null,
      ProjectSaleRemark: null,
    });

    // clear support team
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.clear();
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  addSupport(): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  removeSupportItem(indexitem): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.removeAt(indexitem);
  }

  ClearSearch() {
    this.form.patchValue({
      ProjectSaleCodeSearch: "",
      ProjectSaleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
      ProjectSaleStatusSearch: "",
    });
    this.currentPageNumber = 1;
    this.indexNo = 0;
    //this.LoadProjectSale();
    this.LoadProjectSaleLead();
  }

  async OnLoadMenuFinished(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleList(auth_token);
      this.LoadProjectSaleCountList(auth_token);
    }
  }

  LoadProjectSaleList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumber - 1) * this.environment;

    var objectjson = {};
    objectjson['RoleCode'] = this._ParamProjectGroup;
    objectjson['rowFetch'] = this.environment;
    objectjson['rowOFFSet'] = offset;
    objectjson['CreateBy'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['FlagDelete'] = "N";

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<ModulePortalMappingEmpRoleInfo[]>(this.baseurl + "ModulePortalMappingEmpRole/GetModulePortalMappingEmpRole", strjson, httpOptions)
      .subscribe({
        next: (data) => {
          this.ProjectSaleList = data
        }
      });
  }

  LoadProjectSaleCountList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['RoleCode'] = this._ParamProjectGroup;
    if (this.viewflag == true) {
    }
    else {
      objectjson['CreateBy'] = this.checkUndefinedString(this.empcodeinit);
    }
    objectjson['FlagDelete'] = "N";

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<number>(this.baseurl + "ModulePortalMappingEmpRole/GetCountModulePortalMappingEmpRole", strjson, httpOptions)
      .toPromise().then((data) => {
        this.hidcouchk = data;
        if (this.hidcouchk == 0) this.currentPageNumber = 0;
        this.totalPages = Math.ceil(this.hidcouchk / this.environment);
      })
  }

  async LoadProjectSaleAll() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['FlagActive'] = "Y";
      objectjson['FlagDelete'] = "N";

      if (this.viewflag == true) {
      }
      else {
        objectjson['CreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ModulePortalMappingEmpRoleInfo[]>(this.baseurl + "ModulePortalMappingEmpRole/GetModulePortalMappingEmpRole", strjson, httpOptions)
        .toPromise().then((data) => {
          this.countall = data.length;
        })
    }
  }

  LoadProjectSaleLead(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleLeadUpdatePagination(traget);
    }
  }

  async LoadViewProjectSaleLeadList(ModulePortalId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };
      let offset = (this.currentPageNumber - 1) * this.environment;

      var objectjson = {};
      objectjson['RoleCode'] = this._ParamProjectGroup;
      objectjson['ModulePortalId'] = ModulePortalId;
      objectjson['rowFetch'] = this.environment;
      objectjson['rowOFFSet'] = offset;
      objectjson['ModulePortalMappingMenuCreateBy'] = this.checkUndefinedString(this.empcodeinit);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ModulePortalMappingMenuInfo[]>(this.baseurl + "ModulePortalMappingMenu/GetSelectModulePortalMappingMenu", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ProjectSaleLeadList = data;
          $('#ModalProjectGroupView').modal();
        })
    }
  }

  async LoadProjectSaleLeadList(ModulePortalId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };
      let offset = (this.currentPageNumber - 1) * this.environment;

      var objectjson = {};
      objectjson['RoleCode'] = this._ParamProjectGroup;
      //objectjson['ModulePortalId'] = ModulePortalId;
      objectjson['rowFetch'] = this.environment;
      objectjson['rowOFFSet'] = offset;
      objectjson['ModulePortalMappingMenuCreateBy'] = this.checkUndefinedString(this.empcodeinit);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ModulePortalMappingMenuInfo[]>(this.baseurl + "ModulePortalMappingMenu/GetModulePortalMappingMenu", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ProjectSaleLeadList = data

        })
    }
  }

  async LoadProjectSaleCountLeadList(ModulePortalId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RoleCode'] = this._ParamProjectGroup;
      objectjson['ModulePortalId'] = ModulePortalId;
      objectjson['ModulePortalMappingMenuCreateBy'] = this.checkUndefinedString(this.empcodeinit);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ModulePortalMappingMenuInfo[]>(this.baseurl + "ModulePortalMappingMenu/GetSelectModulePortalMappingMenu", strjson, httpOptions)
        .toPromise().then((data) => {
          this.hidcouchk = data.length;
          if (this.hidcouchk == 0) {
            this.currentPageNumber = 0;
            this.totalPages = 0;
          } else {
            this.totalPages = Math.ceil(this.hidcouchk / this.environment);
          }
        })
    }
  }


  async btnClick_submitInsertProjectSale() {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log('form submitted');
        this.OnCreating('y');

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['RoleCode'] = this._ParamProjectGroup;
        objectjson['ModuleId'] = this.checkUndefinedString(this.form.controls['ModuleId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ModuleId'].value)) : 0;
        objectjson['FlagActive'] = this.checkUndefinedString(this.form.controls['FlagActive'].value) != "" ? this.checkUndefinedString(this.form.controls['FlagActive'].value) : null;
        objectjson['CreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['FlagDelete'] = "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ModulePortalMappingEmpRoleInfo[]>(this.baseurl + "ModulePortalMappingEmpRole/InsertModulePortalMappingEmpRole", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              $('#ModalCreateComplate').modal();
              this.currentPageNumber = 1;
              this.indexNo = 0;
              this.OnLoadMenuFinished();
            }
          )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
    }
  }

  btnClick_onUpdateProjectSale(id) {
    $('#ModalProjectSale').modal('hide');
    this.Clearinput();
    this.isOnUpdate = true

    let index = this.ProjectSaleList.findIndex(x => x.MappingEmpRoleId == id);
    
    // get json object from field SupportTeam

    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var yearcurrent = d.getFullYear();

    this.form.patchValue({
      RoleCode: this.ProjectSaleList[index].RoleCode != null ? this.ProjectSaleList[index].RoleCode : null,
      ModuleId: this.ProjectSaleList[index].ModuleId != null ? this.ProjectSaleList[index].ModuleId : null,
      FlagActive: this.ProjectSaleList[index].FlagActive != null ? this.ProjectSaleList[index].FlagActive : null,
    });

    this.hidProjectSaleId = this.ProjectSaleList[index].MappingEmpRoleId

    $('#ModalProjectSale').modal();
  }

  async btnClick_submitUpdateProjectSale(id) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');

        id = this.hidProjectSaleId

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['MappingEmpRoleId'] = id;
        objectjson['RoleCode'] = this.checkUndefinedString(this.form.controls['RoleCode'].value);
        objectjson['ModuleId'] = this.checkUndefinedString(this.form.controls['ModuleId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ModuleId'].value)) : 0;
        objectjson['FlagActive'] = this.checkUndefinedString(this.form.controls['FlagActive'].value) != "" ? this.checkUndefinedString(this.form.controls['FlagActive'].value) : null;
        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ModulePortalMappingEmpRoleInfo[]>(this.baseurl + "ModulePortalMappingEmpRole/UpdateModulePortalMappingEmpRole", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdating('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdating('n');
              $('#ModalUpdateComplate').modal();

              this.OnLoadMenuFinished();
              this.LoadProjectSaleAll();


            }
          )
      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
    }
  }
  btnClick_addProjectSaleLead(auth_token, id, ModulePortalId, MenuId, ModulePortalMappingMenuSeq, MenuName): Observable<ModulePortalMappingMenuInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ModulePortalMappingMenuId'] = id;
    objectjson['ModulePortalMappingMenuDescription'] = MenuName;
    objectjson['MenuId'] = MenuId;
    objectjson['ModulePortalMappingMenuSeq'] = ModulePortalMappingMenuSeq;
    objectjson['ModulePortalId'] = this.currentModuleID;
    objectjson['ModulePortalMappingMenuActiveFlag'] = 'Y';
    objectjson['ModulePortalMappingMenuCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
    objectjson['RoleCode'] = this._ParamProjectGroup;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ModulePortalMappingMenuInfo[]>(this.baseurl + "ModulePortalMappingMenu/InsertModulePortalMappingMenu", strjsonCusInfo, httpOptions);

  }

  btnClick_updateProjectSaleLead(auth_token, id, ModulePortalId, MenuId, ModulePortalMappingMenuSeq, ModulePortalMappingMenuDescription): Observable<ModulePortalMappingMenuInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ModulePortalMappingMenuId'] = id;
    objectjson['ModulePortalMappingMenuDescription'] = ModulePortalMappingMenuDescription;
    objectjson['MenuId'] = MenuId;
    objectjson['ModulePortalMappingMenuSeq'] = ModulePortalMappingMenuSeq;
    objectjson['ModulePortalId'] = this.currentModuleID;
    objectjson['ModulePortalMappingMenuActiveFlag'] = 'Y';
    objectjson['ModulePortalMappingMenuCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ModulePortalMappingMenuInfo[]>(this.baseurl + "ModulePortalMappingMenu/UpdateModulePortalMappingMenu", strjsonCusInfo, httpOptions);

  }

  chkallclicklead(traget, ModulePortalId) {
    var check = $(traget.currentTarget).is(":checked");
    $('[name="checkboxProjectSaleLead"]').prop('checked', check);
  }

  async btnClick_addProjectSaleLeaditem(id, ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, MenuName) {

    if (confirm("Are you sure you want to update this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_addProjectSaleLead(auth_token, parseInt(id), ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, String(MenuName)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalProjectGroup').modal('hide');
              $('#ModalAddComplate').modal('show');
              this.OnLoadMenuFinished();
              this.LoadProjectSaleAll();
            }
          );
      }
    }
  }

  async btnClick_updateProjectSaleLeaditem(id, ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, ModulePortalMappingMenuDescription, ModulePortalMappingMenuSeq) {

    if (confirm("Are you sure you want to update this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_updateProjectSaleLead(auth_token, parseInt(id), ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, String(ModulePortalMappingMenuDescription)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalProjectGroup').modal('hide');
              $('#ModalUpdateComplate').modal('show');
              this.OnLoadMenuFinished();
              this.LoadProjectSaleAll();
            }
          );
      }
    }
  }

  //Delete แบบ list
  async btnClick_onUpdateProjectSaleLeadList(ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, ModulePortalMappingMenuDescription) {

    if (confirm("Are you sure you want to update this Project?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedProjectSaleLead = $('[name="checkboxProjectSaleLead"]:checked');

        let num = checkkedProjectSaleLead.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSaleLead[i];
          observableBatch.push(this.btnClick_updateProjectSaleLead(auth_token, parseInt(ProjectSalecurrent.value), ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, String(ModulePortalMappingMenuDescription)).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(val => {

          this.SendListIdToUpdate(observableBatch);

        });
      }
    }
  }
  async SendListIdToUpdate(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSale", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalUpdateComplate').modal('show');
            this.currentPageNumber = 1;
            this.OnLoadMenuFinished();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  btnClick_deleteProjectSale(auth_token, id): Observable<ModulePortalMappingEmpRoleInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['MappingEmpRoleId'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ModulePortalMappingEmpRoleInfo[]>(this.baseurl + "ModulePortalMappingEmpRole/DeleteModulePortalMappingEmpRole", strjsonCusInfo, httpOptions);
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSale"]').prop('checked', check);

  }

  async btnClick_deleteProjectSaleitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteProjectSale(auth_token, parseInt(id)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              this.OnLoadMenuFinished();
              this.LoadProjectSaleAll();
            }
          );
      }
    }

  }

  //Delete แบบ list
  async btnClick_onDeleteProjectSaleList() {

    if (confirm("Are you sure you want to delete this Project?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

        let num = checkkedProjectSale.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
          observableBatch.push(this.btnClick_deleteProjectSale(auth_token, parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(val => {

          this.SendListIdToDelete(observableBatch);

        });
      }
    }
  }
  async SendListIdToDelete(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ModulePortalMappingEmpRoleInfo[]>(this.baseurl + "ModulePortalMappingEmpRole/DeleteListModulePortalMappingEmpRole", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            this.OnLoadMenuFinished();
            this.LoadProjectSaleAll();

          }
        );
    }
  }


  async btnClick_updateProjectMappingitem(id, ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, ModulePortalMappingMenuDescription) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_updateProjectSaleLead(auth_token, parseInt(id), ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, String(ModulePortalMappingMenuDescription)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              this.OnLoadMenuFinished();
              this.LoadProjectSaleAll();
            }
          );
      }
    }
  }

  //Delete แบบ list
  async btnClick_onUpdateProjectMappingList(ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, ModulePortalMappingMenuDescription) {

    if (confirm("Are you sure you want to delete this Project?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedProjectSaleLead = $('[name="checkboxProjectSaleLead"]:checked');

        let num = checkkedProjectSaleLead.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSaleLead[i];
          observableBatch.push(this.btnClick_updateProjectSaleLead(auth_token, parseInt(ProjectSalecurrent.value), ModulePortalId, MenuId, ModulePortalMappingMenuActiveFlag, String(ModulePortalMappingMenuDescription)).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(val => {

          this.SendListIdToUpdateMapping(observableBatch);

        });
      }
    }

  }
  async SendListIdToUpdateMapping(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSale", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            this.OnLoadMenuFinished();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  btnClick_deleteProjectMapping(auth_token, id): Observable<ProjectSaleInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ProjectSaleId'] = id;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/DeleteProjectGroupMapping", strjsonCusInfo, httpOptions);

  }

  async btnClick_deleteProjectMappingitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteProjectSale(auth_token, parseInt(id)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              this.OnLoadMenuFinished();
              this.LoadProjectSaleAll();
            }
          );
      }
    }
  }

  //Delete แบบ list
  async btnClick_onDeleteProjectMappingList() {

    if (confirm("Are you sure you want to delete this Project?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

        let num = checkkedProjectSale.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
          observableBatch.push(this.btnClick_deleteProjectSale(auth_token, parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(val => {

          this.SendListIdToDelete(observableBatch);

        });

      }
    }

  }

  btnClick_deleteProjectMappingMenu(auth_token, id): Observable<ModulePortalMappingMenuInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ModulePortalMappingMenuId'] = id;
    objectjson['ModulePortalMappingMenuActiveFlag'] = "Y";

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ModulePortalMappingMenuInfo[]>(this.baseurl + "ModulePortalMappingMenu/DeleteModulePortalMappingMenu", strjsonCusInfo, httpOptions);

  }

  async btnClick_deleteModulePortalMappingMenuitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.btnClick_deleteProjectMappingMenu(auth_token, parseInt(id)).toPromise()
          .then(
            data => {
              console.log('หลังรับค่า');
              $('#ModalDeleteComplate').modal('show');
              $('#ModalProjectGroup').modal('hide');
              $('#ModalProjectGroupView').modal('hide');
            }
          );
      }
    }
  }

  btnClick_onCreateProjectSale() {
    this.form.reset();
    $('#ModalProjectSale').modal('show');
    this.Clearinput();
    this.isOnUpdate = false

  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  async loadModulePortal() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      //objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ModulePortalInfo[]>(this.baseurl + "ModulePortal/GetModulePortal", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  CheckduplicateProjectSaleCode() {
    if (this.isOnUpdate == true) {
      return false;
    }
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  ConvertDate(DateValue) {
    if (DateValue) {

      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daystr = '';

      if (day < 10) {
        daystr = '0' + day
      } else {
        daystr = day.toString();
      }


      var monthIndex = date.getMonth() + 1;
      var monthstr = '';

      if (monthIndex < 10) {
        monthstr = '0' + monthIndex
      } else {
        monthstr = monthIndex.toString();
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();

      var Datenow = '';

      Datenow = monthstr + "/" + daystr + "/" + year;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }

  displayhyperlink(projectcode: string, projectsaleid: number) {
    var body = ""
    body += " <a href=\"/saletracking-management?ProjectSaleID=" + projectsaleid + "\">" + projectcode + "</a>"

    return body;
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear() + 5
    var min = max - 5
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }

  btnonclick_loadCategory() {
    this.loadLookup('PROJECTSALECATEGORY').then((data) => {
      this.CategoryList = data;
    });
  }

  btnClick_onAssignEmpClick() {
    $('#ModalEmpAssign').modal('show');
  }

  ClearSearchEmp() {
    this.form.patchValue({
      EmpCodeSearch: "",
      EmpNameSearch: "",
    });
  }

  //loadDDLModule(auth_token) {
  //  const httpOptions = {
  //    headers: new HttpHeaders({
  //      'Content-Type': 'application/json',
  //      'Authorization': `Bearer ${auth_token}`
  //    })
  //  };
  //  let strjson = "{}";

  //  this.httpClient.post<ModulePortalInfo[]>(this.baseurl + "ModulePortal/GetModulePortal", strjson, httpOptions)
  //    .toPromise().then((data) => {
  //      this.ModuleList = data
  //    })

  //}

  LoadEmp() {
    this.LoadEmpList()
      .then(
        data => {
          this.empList = data;
        }
      ).then(() => {
        this.CountEmpList();
      })
  }

  async LoadEmpList(): Promise<EmpInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
      objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
      objectjson['FlagDelete'] = 'N';
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.empListPromise = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise()

      return this.empListPromise;
    }
  }

  async CountEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
      objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
      objectjson['FlagDelete'] = 'N';

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmployeeCriteria", strjson, httpOptions)
        .toPromise().then(data => {
          this.EmpTotal = data;
          if (this.EmpTotal == 0) this.currentPageNumberEmp = 0;
        })
        .then(() => {
          this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSize);
        })
    }
  }

  btnClickshowEmp() {
    this.LoadEmpforAssign();

  }

  btnClick_previous() {
    if (this.currentPageNumberEmp == 1) {

    } else {
      this.currentPageNumberEmp -= 1
      this.LoadEmp();
    }

  }

  btnClick_next() {
    if (this.currentPageNumberEmp == this.totalPagesEmp) {

    } else {
      this.currentPageNumberEmp += 1
      this.LoadEmp();
    }
  }

  btnClick_first() {
    if (this.currentPageNumberEmp == 1) {

    } else {
      this.currentPageNumberEmp = 1
      this.LoadEmp();
    }

  }

  btnClick_last() {
    if (this.currentPageNumberEmp == this.totalPagesEmp) {

    } else {
      this.currentPageNumberEmp = this.totalPagesEmp
      this.LoadEmp();
    }
  }

  LoadSaleOrganizationLevel() {

    this.LoadSaleOrganizationLevelList().then(data => {
      this.saleOrganizationList = data;

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].AssignFlag == 'Y') {
          this.hidebutton = false;
          this.assignflag = false;
        }
        else {
          this.hidebutton = true;
          this.assignflag = true;
        }
      }
      else {
        this.hidebutton = true;
        this.assignflag = true;
      }

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].ViewFlag == 'Y') {
          this.viewflag = true;
        }
        else {
          this.viewflag = false;
        }
      }
      else {
        this.viewflag = false;
      }

      if (this.saleOrganizationList.length > 0) {
        this.saleorglevelemplogin = this.saleOrganizationList[0].Levels
      }
      else {
        this.saleorglevelemplogin = 1;
      }

      this.OnLoadMenuFinished();
      this.LoadProjectSaleAll();
    }).then(() => {
      this.LoadSaleOrganizationLevelmax();

    });
  }

  async LoadSaleOrganizationLevelList(): Promise<SaleOrganizationInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.empcodeinit);

      let strjson = JSON.stringify(objectjson);

      this.saleOrganizationPromise = this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise()

      return this.saleOrganizationPromise;
    }
  }

  async LoadSaleOrganizationLevelmax() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise().then(
          data => {
            this.saleOrganizationMaxList = data;
            this.saleOrganizationMaxList = this.saleOrganizationMaxList.sort((a, b) => a.Levels - b.Levels);

            if (this.saleOrganizationMaxList.length > 0) {
              this.saleorglevelmax = this.saleOrganizationMaxList[this.saleOrganizationMaxList.length - 1].Levels;

            }
            else {
              this.saleorglevelmax = 1;
            }

            this.LoadEmpforAssign();
          })
    }
  }

  async LoadEmpforAssign() {
    if (this.saleorglevelemplogin > 1 && this.saleorglevelmax > 1) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
          })
        };

        let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

        var objectjson = {};
        objectjson['saleorglevel'] = this.saleorglevelemplogin;
        objectjson['saleorglevelmax'] = this.saleorglevelmax;
        objectjson['rowFetch'] = environment.PageSize;
        objectjson['rowOFFSet'] = offset;
        objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
        objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmpforAssignProjectSale", strjson, httpOptions)
          .toPromise().then(
            data => {
              this.empListLoad = data;
              //console.log("JSON result empassign : " + JSON.stringify(this.empListLoad));
            }).then(() => {
              this.CountLoadEmpforAssign();
            })
      }
    }
    else {
      this.empListLoad = [];
      //console.log("JSON result empassign : " + JSON.stringify(this.empListLoad));
    }
  }

  async CountLoadEmpforAssign() {
    if (this.saleorglevelemplogin > 1 && this.saleorglevelmax > 1) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json', 'Authorization': `Bearer ${auth_token}`
          })
        };

        let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

        var objectjson = {};
        objectjson['saleorglevel'] = this.saleorglevelemplogin;
        objectjson['saleorglevelmax'] = this.saleorglevelmax;
        objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
        objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmpforAssignProjectSale", strjson, httpOptions)
          .toPromise().then(data => {
            this.EmpTotal = data;
            if (this.EmpTotal == 0) this.currentPageNumber = 0;
          })
          .then(() => {
            this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSize);
          })
      }
    }
    else {
      this.EmpTotal = 0;
    }

  }


  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }
  // Function Update variable abount pagination
  LoadProjectSaleLeadUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }

  //Lead group
  //function Update Group projectsale
  //1. Get list project group to modal
  //2. Send list projs id to save 
  //Variables
  listProjGroup: ProjectGroupInfo[] = [];
  totalProjectGroup: number;
  totalPage_ProjectGroup: number;
  currentPageNumber_ProjectGroup: number;

  OnBtnOpenProjectGroupModalClick(ModuleId) {
    this.currentModuleID = ModuleId
    this.LoadProjectSaleLeadList(ModuleId);
    $('#ModalProjectGroup').modal();
  }
  async OnBtnOpenProjectGroupViewModalClick(ModuleId) {
    this.currentModuleID = ModuleId
    await this.LoadViewProjectSaleLeadList(ModuleId);
    
  }


}
